import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Contact } from "../components/contact";

const CollapsibleSection = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="panel panel-default" style={{ marginTop: "20px" }}>
      <div className="panel-heading" style={{ cursor: "pointer" }} onClick={() => setIsOpen(!isOpen)}>
        <h4 style={{ margin: "0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {title}
          <span style={{ fontSize: "18px" }}>{isOpen ? "−" : "+"}</span>
        </h4>
      </div>
      {isOpen && <div className="panel-body">{children}</div>}
    </div>
  );
};

export const UltrasonicDeepfryerVSeries = ({ data }) => {
  return (
    <>
      <div id="product-detail" style={{ padding: "100px 0" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Link to="/product-catalogue" className="btn btn-default" style={{ marginBottom: "20px" }}>
                <i className="fa fa-arrow-left"></i> Back to Catalogue
              </Link>
              <div className="section-title">
                <h2>Ultrasonic Deepfrier EW7000 Series</h2>
                <p>The Future of Commercial Frying Technology</p>
                <img src="/img/products/mp-ew7000.png" alt="Ultrasonic Deepfrier EF-V Series" style={{ maxWidth: "300px", marginBottom: "20px", display: "block" }} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <h3>Product Overview</h3>
              <p>
                The EF-V Series utilizes advanced ultrasonic cavitation technology to revolutionize the frying process. By emitting high-frequency sound waves (28kHz/40kHz) into the cooking oil, it creates millions of microscopic vacuum bubbles that implode, significantly enhancing heat transfer and ensuring uniform cooking.
              </p>
            </div>
          </div>

          <div className="row" style={{ marginTop: "50px" }}>
            <div className="col-md-12">
              <h3>Key Benefits</h3>
              <div className="row">
                <div className="col-md-3">
                  <p><strong>Enhanced Food Quality</strong><br />Crispier exterior with a tender, moist interior.</p>
                </div>
                <div className="col-md-3">
                  <p><strong>Oil Savings</strong><br />Reduces oil absorption by up to 40% and extends oil life by preventing rapid oxidation.</p>
                </div>
                <div className="col-md-3">
                  <p><strong>High Efficiency</strong><br />Reduces cooking time by 25-30% compared to traditional fryers.</p>
                </div>
                <div className="col-md-3">
                  <p><strong>Energy Efficient</strong><br />Lower temperature requirements for the same results.</p>
                </div>
              </div>
            </div>
          </div>
          

          <div className="row" style={{ marginTop: "50px" }}>
            <div className="col-md-12">
              <h3>Core Features</h3>
              <div className="row">
                <div className="col-md-3">
                  <p><strong>Digital Control Panel</strong><br />Precise timing and temperature settings for consistent results across batches.</p>
                </div>
                <div className="col-md-3">
                  <p><strong>Auto-Sludge Removal</strong><br />Integrated system to filter carbonized particles and maintain oil clarity.</p>
                </div>
                <div className="col-md-3">
                  <p><strong>Safety Interlock</strong><br />Automatic overheat protection and ultrasonic dry-run prevention.</p>
                </div>
                <div className="col-md-3">
                  <p><strong>Advanced Oil Management</strong><br />Rotating heating head design and high-temperature self-locking oil drain valve.</p>
                </div>
              </div>
            </div>
          </div>


          <div className="row" style={{ marginTop: "50px" }}>
            <div className="col-md-12">
              <h3>Technical Specifications</h3>
              <div className="panel panel-default">
                <table className="table">
                  <tbody>
                    <tr>
                      <td><strong>Model Number</strong></td>
                      <td>EW-3000 / EW-7000</td>
                    </tr>
                    <tr>
                      <td><strong>Capacity</strong></td>
                      <td>10 Liters / 40 Liters</td>
                    </tr>
                    <tr>
                      <td><strong>Ultrasonic Power</strong></td>
                      <td>120W - 240W (Adjustable)</td>
                    </tr>
                    <tr>
                      <td><strong>Heating Power</strong></td>
                      <td>3.0kW / 6.0kW</td>
                    </tr>
                    <tr>
                      <td><strong>Temperature Range</strong></td>
                      <td>50°C - 200°C (Digital Control)</td>
                    </tr>
                    <tr>
                      <td><strong>Material</strong></td>
                      <td>Food Grade SUS304 Stainless Steel</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginTop: "50px" }}>
            <div className="col-md-12">
              <h3>Installation & Operation</h3>

              <CollapsibleSection title="Installation Precautions">
                <ul className="bullet-list">
                  <li>Check power supply voltage matches the nameplate</li>
                  <li>Connect to independent power supply with leakage and over-current protection (full-pole disconnect switch, contact gap &gt;3mm)</li>
                  <li>Properly ground the fryer with at least 2.5mm² copper wire to the equipotential grounding terminal</li>
                  <li>Do NOT connect ground to water, gas, or heating pipes</li>
                  <li>Avoid flammable/explosive materials; ensure good ventilation</li>
                  <li>Never operate without oil (damages heating element)</li>
                  <li>Keep away from children; provide supervision if children are present</li>
                </ul>
              </CollapsibleSection>

              <CollapsibleSection title="Operating Instructions">
                <ul className="bullet-list">
                  <li>Fill oil tank between min/max marks</li>
                  <li>Turn temperature control to "0"</li>
                  <li>Connect to power; indicator light turns on</li>
                  <li>Adjust thermostat to desired temperature (60-190°C range)</li>
                  <li>Heating indicator illuminates when heating starts</li>
                  <li>Thermostat auto-cuts power when temperature reached</li>
                  <li>Place food in basket and lower into oil</li>
                  <li>Keep tank cover dry (water can cause splashing)</li>
                  <li>Tilt control box backward 90° after frying to drain residual oil</li>
                  <li>Set temperature limiter slightly higher than thermostat</li>
                  <li>Turn knob to "0" and disconnect after use</li>
                </ul>
              </CollapsibleSection>

              <CollapsibleSection title="Maintenance and Cleaning">
                <ul className="bullet-list">
                  <li>Use soft cloth with non-corrosive cleaners</li>
                  <li>Always disconnect power before maintenance</li>
                  <li>Do NOT spray/rinse with water</li>
                  <li>Wait for oil to cool to room temperature before draining</li>
                  <li>Store in well-ventilated, corrosive-gas-free environment if not used long-term</li>
                </ul>
              </CollapsibleSection>

              <CollapsibleSection title="Troubleshooting">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <td><strong>Heating on but no heating</strong></td>
                      <td>Replace heating element or inspect thermostat/limiter</td>
                    </tr>
                    <tr>
                      <td><strong>Indicator light issues</strong></td>
                      <td>Replace indicator light or check wiring</td>
                    </tr>
                    <tr>
                      <td><strong>Oil temperature uncontrollable</strong></td>
                      <td>Inspect/replace thermostat or limiter</td>
                    </tr>
                  </tbody>
                </table>
              </CollapsibleSection>

              <CollapsibleSection title="Warranty Information">
                <ul>
                  <li><strong>Coverage:</strong> 3 months free repair under normal use, lifetime maintenance</li>
                  <li><strong>Requirements:</strong> Purchase receipt and warranty card</li>
                  <li><strong>After Warranty:</strong> Charged repairs apply after warranty expires</li>
                  <li><strong>Exclusions:</strong> Unauthorized disassembly, dry heating, accidents, transportation damage, etc.</li>
                </ul>
              </CollapsibleSection>
            </div>
          </div>
        </div>
      </div>
      <Contact data={data.Contact} />
    </>
  );
};